import { render } from "./XIconSolidTerminalWindow.vue?vue&type=template&id=4d476acc"
import script from "./XIconSolidTerminalWindow.vue?vue&type=script&lang=js"
export * from "./XIconSolidTerminalWindow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidTerminalWindow.vue"]])

export default __exports__